export class BillingDiscrepancyRequestTypeFilter {
    public IncludeInactive?: boolean;
}

export default BillingDiscrepancyRequestTypeFilter;